import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Allows `/employee/**` only while the app is in employee portal mode. */
export const employeeGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.portal() === 'employee') {
    return true;
  }
  return router.createUrlTree(['/admin/dashboard']);
};
